export default {
  items: [],
  sort: {
    page: 1,
    column: 'name',
    order: 'ascending',
    limit: 50,
  },
  more: true,
  loading: false,
  total: 0,
};
